import { render, staticRenderFns } from "./yunxing.vue?vue&type=template&id=6ded1360&scoped=true"
import script from "./yunxing.vue?vue&type=script&lang=js"
export * from "./yunxing.vue?vue&type=script&lang=js"
import style0 from "./yunxing.vue?vue&type=style&index=0&id=6ded1360&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ded1360",
  null
  
)

export default component.exports